import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/recursos_humanos/departamentos';
import RecursosHumanos from './RecursosHumanos';


const ms2p = (state) => {
  return {
    ...state.departamento,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(RecursosHumanos);
